<template>
	<v-container fluid>
		<v-row>
			<!-- Left Column: Inputs (less than 50% width) -->
			<!-- <v-col cols="12" md="3">
				<v-card class="rounded-xl py-3">
					<v-card-text>
						<v-row>
							<v-col cols="12" class="s-col-form"
								v-if="params.TypePrice == 1 || params.TypePrice == 3 || params.TypePrice == 2 || params.TypePrice == 5">
								<s-select-payment full :typeCultive="params.TypeCultive"
									:TypeDestiny="params.TypeDestiny" label="Tipo Calibre" text="CategoryCaliberText"
									v-model="form.CtgID"></s-select-payment>
							</v-col>
							<v-col cols="12" class="s-col-form">
								<s-text decimal label="Monto" ref="CfpAmount" v-model="form.CfpAmount"></s-text>
							</v-col>
							<v-col cols="12" class="s-col-form"
								v-if="params.TypePrice == 1 || params.TypePrice == 2 || params.TypePrice == 3 || params.TypePrice == 5">
								<s-text decimal label="Monto Descarte" ref="CfpAmountDiscard"
									v-model="form.CfpAmountDiscard"></s-text>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col> -->

			<!-- Right Column: Other Content (rest of the space) -->
			<v-col cols="12" md="12">

				<v-card class="rounded-xl py-3 mb-4">
					<v-card-text>
						<div class="text-subtitle-2 font-weight-bold mb-5">
							FILTROS
						</div>
						<v-row>
							<v-col cols="4" class="s-col-form">
								<s-select-definition :def="1201" label="Tipo Precio" text="TypePriceText"
									v-model="params.TypePrice"></s-select-definition>
							</v-col>
							<v-col cols="4" class="s-col-form" v-if="params.TypePrice == 5">
								<s-select-definition :def="1610" label="Tipo de Negociación" text="TypeNegociationText"
									v-model="params.TypeNegociation"></s-select-definition>
							</v-col>
							<v-col cols="4" class="s-col-form">
								<s-select-definition :def="1129" label="Tipo de moneda"
									v-model="params.TypeCurrency"></s-select-definition>
							</v-col>
							<v-col cols="4" class="s-col-form" v-if="params.TypePrice != 3">
								<s-select-definition clearable label="Zona" :def="1253" v-model="params.TypeZonLocation"
									ref="ZneRef"></s-select-definition>
							</v-col>
							<v-col cols="4" class="s-col-form">
								<s-select-definition label="Destino" :def="1342"
									v-model="params.TypeDestiny"></s-select-definition>
							</v-col>
							<v-col cols="4" class="s-col-form">
								<s-select-definition v-model="params.TypeCrop" :def="1172" label="Tipo de cultivo" />
							</v-col>
							<v-col cols="4" class="s-col-form">
								<s-select-definition v-model="params.TypeCultive" :def="1173" label="Cultivo" />
							</v-col>
							<v-col cols="4" class="s-col-form">
								<s-select-variety :text="params.HvsCultiveText" :cultiveID="params.TypeCultive"
									label="Variedad" v-model="params.VrtID" />
							</v-col>

							<v-col cols="4" class="s-col-form">
								<s-date label="Fecha Inicio" v-model="params.cDateInitial"></s-date>
							</v-col>
							<v-col cols="4" class="s-col-form">
								<s-date label="Fecha Fin" v-model="params.cDateFin"></s-date>
							</v-col>
							<v-col cols="4" class="s-col-form" v-if="params.TypePrice == 3">
								<s-select-producer label="Productor" text="PrdCardName" v-model="form.PrdID"
									return-object @input="change($event)"></s-select-producer>
							</v-col>
							<v-col cols="4" class="s-col-form" v-if="params.TypePrice == 2">
								<s-select-type-certification label="Tipo Certificado" full
									:text="form.TypeCertificationText" v-model="form.CrtID">
								</s-select-type-certification>
							</v-col>

						</v-row>
					</v-card-text>
				</v-card>

				<v-card class="rounded-xl mb-4 d-flex flex-column" style="min-height: 60vh;">
					<!-- Card principal -->

					<v-card-text class="d-flex flex-column flex-grow-1">

						<v-row class="d-flex flex-grow-1" style="height: 100%;">
							<!-- Row ocupa todo el alto -->

							<!-- Columna formulario -->
							<v-col cols="12" md="4" class="d-flex flex-column">
								<v-card class="rounded-xl py-3 flex-grow-1" style="overflow-y: auto; max-height: 70vh;">
									<v-card-text class="d-flex flex-column">
										<!-- Encabezado con texto a la izquierda y botones a la derecha -->
										<v-row class="align-center mb-1">
											<div class="text-subtitle-2 font-weight-bold">
												Configuración de Precios
											</div>
											<v-spacer></v-spacer>
											<v-btn x-small fab color="warning" class="mr-2" @click="clearPaymentEdit">
												<i class="fas fa-broom"></i>
											</v-btn>
											<v-btn x-small fab color="primary" class="mr-2" @click="addPayment">
												<i class="fas fa-plus"></i>
											</v-btn>
										</v-row>

										<!-- Formulario -->
										<v-row class="flex-column mb-2">
											<v-col cols="12" class="s-col-form"
												v-show="[1, 2, 3, 5].includes(params.TypePrice)">
												<s-select-payment full :typeCultive="params.TypeCultive"
													:TypeDestiny="params.TypeDestiny" label="Tipo Calibre"
													text="CategoryCaliberText" v-model="objPayment" return-object />
											</v-col>

											<v-col cols="12" class="s-col-form">
												<s-text decimal label="Monto" ref="CfpAmount"
													v-model="form.CfpAmount"></s-text>
											</v-col>

											<v-col cols="12" class="s-col-form"
												v-if="params.TypePrice == 1 || params.TypePrice == 2 || params.TypePrice == 3 || params.TypePrice == 5">
												<s-text decimal label="Monto Descarte" ref="CfpAmountDiscard"
													v-model="form.CfpAmountDiscard">
												</s-text>
											</v-col>

										</v-row>
										<v-row class="s-col-form">
											<v-data-table v-model="selectedPrecios" :headers="headerPrecios" dense
												height="250px" :items="itemsPrecios" hide-default-footer item-key="Line"
												label="Edit" singleSelect show-select class="elevation-0"
												@item-selected="dblclick($event)">
												<template v-slot:item.Actions="{ item }">
													<v-btn block color="error" @click="removeCapataz(item)" x-small>
														<v-icon>mdi-close</v-icon></v-btn>
												</template>
											</v-data-table>
										</v-row>

									</v-card-text>
								</v-card>
							</v-col>

							<!-- Columna tabla -->
							<v-col cols="12" md="8" class="d-flex flex-column">
								<v-data-table :headers="headers" :items="items" :items-per-page="-1" item-key="RcfID"
									show-select class="elevation-0 flex-grow-1" :loading="loadingItems" height="500px"
									v-model="selected" id="crudprices">
									<!-- Slots de la tabla -->
									<template v-slot:item.ViewCert="{ item }">
										<v-btn x-small color="info" block outlined @click="clickView(item)">
											<v-icon style="font-size: 16px !important">fas fa-eye</v-icon>
										</v-btn>
									</template>

									<template v-slot:item.UploadFile="{ item }">
										<v-btn x-small :color="item.HvsAttach ? '#6ad898' : '#b2b2b2'" block outlined
											@click="clickUploadFile(item)">
											<v-icon style="font-size: 16px !important">
												{{ item.HvsAttach ? 'fas fa-file-alt' : 'fas fa-file' }}
											</v-icon>
										</v-btn>
									</template>

									<template v-slot:item.RcsDateHarvestSchedule="{ item }">
										{{ $fun.formatDateView(item.RcsDateHarvestSchedule) }}
									</template>

									<template v-slot:item.RcfDateReceptionSurveillance="{ item }">
										{{ $fun.formatDateView(item.RcfDateReceptionSurveillance) }}
									</template>

									<template v-slot:item.RcfState="{ item }">
										<v-chip x-small :color="item.TypeStateColor" class="px-1">
											{{ item.TypeStateName }}
										</v-chip>
									</template>

									<template v-slot:item.TypeAlert="{ item }">
										<v-chip x-small :color="item.TypeAlertColor" class="px-1">
											{{ item.TypeAlertName }}
										</v-chip>
									</template>

									<template v-slot:item.CloseLot="{ item }">
										<v-btn v-if="item.RcfState < 4 && item.Sampling == 1" x-small
											:color="item.TypeStateColor" rounded
											style="border-radius: 10px; text-transform: none" @click="closeLot(item)">
											Cerrar
										</v-btn>
									</template>

									<template v-slot:item.WeightGuideVB="{ item }">
										<v-switch disabled style="margin-top: -1px" hide-details
											:input-value="item.RcfWeightGuide > 0" hide-spin-buttons></v-switch>
									</template>

									<template v-slot:item.actions="{ item, index }">
										<v-btn x-small color="primary" @click="viewDetail(item)">
											<v-icon small>mdi-eye</v-icon>
											Ver
										</v-btn>
									</template>
								</v-data-table>

								<!-- Botón guardar abajo -->
								<div class="d-flex justify-end ">
									<v-tooltip bottom v-if="selected.length > 0">
										<template v-slot:activator="{ on, attrs }">
											<v-btn color="primary" @click="savePrices()" v-bind="attrs" v-on="on"
												class="white--text darken-2 rounded-lg">
												Guardar
												<v-icon right>mdi-content-save</v-icon>
											</v-btn>
										</template>
										<span>Guardar</span>
									</v-tooltip>
								</div>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>


			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import sSelectedZona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedZona";
import SSelectDefinition from "../../../components/Utils/SSelectDefinition.vue";
import SText from "../../../components/Utils/SText.vue";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import sProducerService from "@/services/Technicalassistance/ConfigurationPrice";
import sSelectPayment from "@/components/CategoryPayment/SSelectPayment.vue";
import SSelectTypeCertification from "../../../components/Utils/Certification/sSelectTypeCertification.vue";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
import _sReceptionFresh from "@/services/FreshProduction/ReceptionFreshService";

export default {
	components: {
		SText,
		sSelectedZona,
		SSelectDefinition,
		SSelectProducer,
		sProducerService,
		sSelectPayment,
		SSelectTypeCertification,
		SSelectVariety,
	},
	data: () => ({
		PrdCardCode: '',
		form: {
			PrdID: null,
			TypePriceText: '',
			CategoryCaliberText: '',
			CtgID: 0,
			TypeCertificationText: '',
			CrtID: 0,
			PrdCardName: '',
			CfpAmount: 0,
			CfpAmountDiscard: 0,
			TypeNegociation: null,
		},
		loadingItems: false,
		selected: [],
		params: {
			cDateInitial: '',
			cDateFin: '',
			TypeCurrency: 0,
			TypeCrop: null,
			TypeCultive: 1,
			HvsCultiveText: '',
			VrtID: 0,
			TypePrice: null,
			TypeZonLocation: null,
			TypeDestiny: null,
			PrfID: null,
			TypeNegociation: null,
		},
		items: [],
		headers: [
			// { text: "View", value: "ViewCert", width: 70, align: 'center' },
			// { text: "Archivo", value: "UploadFile", width: 70, align: 'center' },
			// { text: "Cerrar", value: "CloseLot", width: 50, align: 'center' },
			// { text: "Estado", value: "RcfState", width: 20, align: 'center' },
			{ text: "Codigo. Lote.", value: "RcfID", width: 80 },
			{ text: "Tipo N.", value: "TypeNegociationName", width: 50 },
			{ text: "Fec. Cosecha.", value: "RcsDateHarvestSchedule", width: 100, align: 'center' },
			{ text: "Cant. Jabas Pesadas.", value: "AmountJabasWeigh", width: 100 },
			{ text: "Guia Cosecha", value: "RcfNumberHarvestGuide", width: 120 },
			{ text: "Guia Remision", value: "RcfNumberReferralGuide", width: 120 },
			{ text: "Productor", value: "PrdCardName", width: 200 },
			{ text: "Fundo", value: "FagName", width: 200 },
			{ text: "Tipo Cultivo", value: "TypeCropName", width: 100, align: 'center' },
			{ text: "Cultivo", value: "TypeCultiveName", width: 160, align: 'center' },
			{ text: "Variedad", value: "VrtName", width: 100, align: 'center' },
			{ text: "Cod. Senasa", value: "FltCodSenasa", width: 120, align: 'center' },
			// { text: "Fec. Recep. Vigilancia.", value: "RcfDateReceptionSurveillance", width: 100, align: 'center' },
			// { text: "Peso Promedio Fruta", value: "WbbWeightAverage", width: 100 },
			// { text: "Empacadora", value: "TypeBalerName", width: 120, align: 'center' },
			// { text: "Zona Ubicacion", value: "TypeZonLocationName", width: 160 },
			// { text: "Alerta", value: "TypeAlert", width: 80 },
			// { text: "Observaciones", value: "RcfObservations", width: 260 },
			// { text: "Campaña x Área", value: "CmaName", width: 120 },
			// { text: "Rechazar", value: "DeclineLot", width: 50 },
		],
		config: {
			service: _sReceptionFresh,
			model: {
				RcfID: "ID",
				RcfDateReceptionSurveillance: "date",
				RcfState: "",
				CloseLot: "",
				TypeAlert: "",
				ViewCert: "",
				TypeAlertName: "",
				RcsDateHarvestSchedule: "date",
				WeightGuideVB: "",
				DeclineLot: "",
				UploadFile: ""
			},
		},
		dialogFrozenGroup: false,
		itemsPrecios: [],
		selectedPrecios: [],
		objPayment: [],
		headerPrecios: [
			{
				text: "Tipo Calibre",
				value: "calibre",
				width: 120,
				sortable: false,
			},
			{
				text: "Monto",
				value: "monto",
				width: 120,
				sortable: false,
			},
			{
				text: "Monto Descarte",
				value: "montoDescarte",
				width: 120,
				sortable: false,
			},
			{
				text: "Acciones",
				value: "Actions",
				width: 100,
				sortable: false,
			},
		],
	}),
	computed: {
		selectedIds() {
			return this.selected.map(item => item.RcfID);
		}
	},
	watch: {
		params: {
			deep: true,
			handler() {
				this.selected = []
				this.getListRecepcionFrescos()
			}
		},
		"params.TypePrice"(value) {
			this.change(null)
			this.params.PrfID = null
			this.form.PrdID = null
			this.params.TypeZonLocation = null
			this.itemsPrecios = []
			this.clearPaymentEdit()
			console.log('cambio el precio')
			console.log(this.params)
		},
		selected(values) {
			console.log(this.selectedIds)
		}
	},
	methods: {
		savePrices() {

			if (this.selectedIds.length == 0) {
				this.$fun.alert("Seleccionar lote", "warning");
				return
			}
			if (this.params.TypePrice == null) {
				this.$fun.alert("Seleccionar tipo de precio", "warning");
				return
			}
			if (this.params.TypeCurrency == null || this.params.TypeCurrency == 0) {
				this.$fun.alert("Seleccionar tipo de moneda", "warning");
				return
			}
			// if (this.params.TypeZonLocation == null) {
			// 	this.$fun.alert("Seleccionar zona", "warning");
			// 	return
			// }
			if (this.params.TypeDestiny == null) {
				this.$fun.alert("Seleccionar destino", "warning");
				return
			}
			if (this.params.TypePrice == 3 && (this.form.PrdID == null)) {
				this.$fun.alert("Seleccionar productor", "warning");
				return
			}
			if (this.itemsPrecios.length == 0) {
				this.$fun.alert("Agregar al menos un registro de precio en la grilla", "warning");
				return
			}

			// Por cada lote seleccionado genera un registro por cada fila de precio de la grilla
			const datos = this.selected.flatMap(x => {
				return this.itemsPrecios.map(precio => ({
					CfpAmount: precio.monto,
					CfpAmountBolillo: null,
					CfpAmountDevolution: null,
					CfpAmountDiscard: precio.montoDescarte,
					CfpDateBegin: this.params.cDateInitial,
					CfpDateEnd: this.params.cDateFin,
					CfpID: 0,
					CtgID: precio.CtgID, // Tipo Calibre (viene de la grilla)
					TypeCrop: this.params.TypeCrop,
					TypeCultive: this.params.TypeCultive,
					TypeCurrency: this.params.TypeCurrency,
					TypeDestiny: this.params.TypeDestiny,
					TypePrice: this.params.TypePrice,
					UsrCreateID: this.$fun.getUserID(),
					VrtID: this.params.VrtID,
					SecStatus: 1,
					PrdID: x.PrdID,
					ZneID: x.TypeZonLocation,
					RcfID: x.RcfID,
					TypeNegociation: x.TypeNegociation,
				}))
			})
			// console.log({ datos })
			// return

			this.$fun.alert("Seguro de guardar?", "question").then((r) => {
				if (r.value) {
					sProducerService.saveMasive(datos, this.$fun.getUserID()).then((resp) => {
						if (resp.status == 200) {
							this.selected = [];
							this.getListRecepcionFrescos()
							this.$fun.alert("Registrado Correctamente", "success");
							this.clearPaymentEdit();
							this.itemsPrecios = []
							// this.$refs.crudprices.refresh();
						}
					});
				}
			});
		},
		getListRecepcionFrescos() {
			// console.log("params", this.params)
			this.items = []
			this.loadingItems = true;
			_sReceptionFresh.assignmentPrices(this.params, this.$fun.getUserID()).then((result) => {
				// console.log(result)
				this.loadingItems = false;
				this.items = result && result.status == 200 ? result.data : []
			}).catch(error => {
				this.loadingItems = false;
				this.items = []
				console.log(error)
			})
		},
		change(item) {
			if (item && this.params.TypePrice == 3) {
				this.PrdCardCode = item.PrdCardCode;
				this.params.PrfID = item.PrdID;
			} else {
				this.form.PrdID = null;
				this.PrdCardCode = '';
				this.params.PrfID = null;
			}
		},

		// Agrega una fila de precio al datatable
		addPayment() {
			if (this.form.CfpAmount == null || this.form.CfpAmount == 0) {
				this.$fun.alert("Ingrese el Monto", "warning");
				return;
			}

			const needsCaliber = [1, 2, 3, 5].includes(this.params.TypePrice);
			if (needsCaliber && (!this.objPayment || !this.objPayment.CtgID)) {
				this.$fun.alert("Seleccione el Tipo Calibre", "warning");
				return;
			}

			const ctgIDActual = this.objPayment ? this.objPayment.CtgID : 0;
			if (ctgIDActual !== 0) {
				const yaExiste = this.itemsPrecios.find(p => p.CtgID === ctgIDActual);

				if (yaExiste) {
					this.$fun.alert("Este calibre ya está registrado en la lista", "warning");
					return;
				}
			}

			const calibreText = this.objPayment
				? this.objPayment.CtgDescription
				: '-';

			this.itemsPrecios.push({
				Line: Date.now(),
				CtgID: this.objPayment ? this.objPayment.CtgID : 0,
				calibre: calibreText,
				monto: this.form.CfpAmount,
				montoDescarte: this.form.CfpAmountDiscard,
			});

			this.clearPaymentEdit();
		},

		// Limpia el formulario y deselecciona la fila activa
		clearPaymentEdit() {
			this.objPayment = null;
			this.form.CtgID = 0;
			this.form.CfpAmount = 0;
			this.form.CfpAmountDiscard = 0;
			this.selectedPrecios = [];
		},

		// Elimina una fila del datatable de precios
		removeCapataz(item) {
			this.itemsPrecios = this.itemsPrecios.filter(p => p.Line !== item.Line);
			if (this.selectedPrecios.length > 0 && this.selectedPrecios[0].Line === item.Line) {
				this.clearPaymentEdit();
			}
		},

		// Al seleccionar una fila, carga sus datos en el formulario para editar
		dblclick({ item, value }) {
			if (value) {
				// Reconstruye objPayment para que el s-select-payment muestre el valor correcto
				this.objPayment = {
					CtgID: item.CtgID,
					CtgDescription: item.calibre,
					CategoryCaliberText: item.calibre,
				};
				this.form.CtgID = item.CtgID;
				this.form.CfpAmount = item.monto;
				this.form.CfpAmountDiscard = item.montoDescarte;
			} else {
				this.clearPaymentEdit();
			}
		},
	},
	mounted() {
		this.getListRecepcionFrescos()
	}
};
</script>